import { ModulePermissions } from '@config/permissions';

import {
  MemberId,
  MemberProfileId,
  ONLINE_STATUS,
  PROFILE_BLOCK_TYPE,
} from './member-profiles';

export enum GENDER {
  MALE = 1,
  FEMALE = 2,
}

export enum ROLE_TYPE {
  MALE = 1,
  FEMALE = 2,
  AFFILIATE = 3,
}

export enum ADMINISTRATOR_ROLE_TYPE {
  JUNIOR_ADMIN = 4,
  ADMIN = 5,
  SUPER_ADMIN = 6,
}

export type UserAccountId = MemberId;
export type UserProfileId = MemberProfileId;

export type UserAccount = {
  id: UserAccountId;
  name?: string;
  email?: string;
  emailConfirmed: boolean;
  role: ROLE_TYPE;
  registrationTime: string;
  ipAddress?: string;
  ipBlocked?: boolean;
  onlineStatus: ONLINE_STATUS;
};

export type UserAccounts = UserAccount[];

export type UserAccountProfile = {
  id: UserProfileId;
  userId: UserAccountId;
  onlineStatus: ONLINE_STATUS;
  onlineStatusChangeTime?: string;
  roleType: ROLE_TYPE;
  registrationDateTime: string;
  email: string;
  emailIsConfirmed: boolean;
  isDeleted: boolean;
  isBlocked: boolean;
  balance: number;
  isLoginLocked: boolean;
  ipAddress?: string;
  name?: string;
  ipIsBlocked?: boolean;
  isHiddenInSearch?: boolean;
  profileBlockTypeInfo?: PROFILE_BLOCK_TYPE;
  lockTime?: string;
  deleteDateTime?: string;
  emailIsNotify?: boolean;
};

export type AdministratorAccountProfile = Omit<
  UserAccountProfile,
  'roleType'
> & {
  roleType: ADMINISTRATOR_ROLE_TYPE;
  permissions: ModulePermissions;
};
